export const REPORT_PREVIEW_CHARTS_PER_ROW = 1;

export const REPORT_PREVIEW_CHART_HEIGHT_PX = 160;

export const REPORT_PREVIEW_CHART_GRID_GAP_PX = 12;

export const REPORT_PREVIEW_CHART_CARD_CLASS_NAME =
  'tw-gap-3 tw-p-3 tw-shadow-sm';

export const REPORT_PREVIEW_CHART_PLACEHOLDER_CLASS_NAME =
  'tw-h-[160px] tw-w-full';
